export const RISK_CATALOG = [
  {
    id: "arbeidsmiljo",
    title: "Arbeidsmiljø",
    category: "fysisk",
    challenges: [
      { id: "stoy", title: "Støy" },
      { id: "stov", title: "Støv og partikler" },
      { id: "klima_inne", title: "Inneklima" },
      { id: "belysning", title: "Belysning" },
    ],
  },
  {
    id: "maskiner_utstyr",
    title: "Maskiner og utstyr",
    category: "sikkerhet",
    challenges: [
      { id: "maskinvern", title: "Manglende maskinvern" },
      { id: "verktoy", title: "Håndverktøy" },
      { id: "lofteutstyr", title: "Løfteutstyr" },
      { id: "vedlikehold", title: "Vedlikehold og service" },
    ],
  },
  {
    id: "kjemikalier",
    title: "Kjemikalier",
    category: "kjemisk",
    challenges: [
      { id: "eksponering", title: "Kjemisk eksponering" },
      { id: "stoffkartotek", title: "Stoffkartotek og merking" },
      { id: "lagring", title: "Lagring av kjemikalier" },
    ],
  },
  {
    id: "fall_hoyde",
    title: "Fall og arbeid i høyden",
    category: "fysisk",
    challenges: [
      { id: "stillas", title: "Stillas og arbeidsplattform" },
      { id: "stige", title: "Stige" },
      { id: "tak", title: "Tak- og fasadearbeid" },
    ],
  },
  {
    id: "organisatorisk",
    title: "Organisatorisk",
    category: "organisatorisk",
    challenges: [
      { id: "arbeidstid", title: "Arbeidstid og skift" },
      { id: "opplaering", title: "Opplæring og kompetanse" },
      { id: "alene", title: "Alenearbeid" },
      { id: "kommunikasjon", title: "Kommunikasjon og varsling" },
    ],
  },
  {
    id: "psykososialt",
    title: "Psykososialt",
    category: "psykososialt",
    challenges: [
      { id: "stress", title: "Stress og arbeidspress" },
      { id: "trakassering", title: "Trakassering og konflikter" },
      { id: "vold", title: "Vold og trusler" },
    ],
  },
  {
    id: "klima_miljo",
    title: "Klima og miljø",
    category: "miljo",
    challenges: [
      { id: "ekstremvaer", title: "Ekstremvær" },
      { id: "utslipp", title: "Utslipp og avfall" },
      { id: "energi", title: "Energibruk" },
    ],
  },
  {
    id: "brann_eksplosjon",
    title: "Brann og eksplosjon",
    category: "sikkerhet",
    challenges: [
      { id: "brannfarlig", title: "Brannfarlig materiale" },
      { id: "varme_arbeider", title: "Varme arbeider" },
    ],
  },
  {
    id: "trafikk_transport",
    title: "Trafikk og transport",
    category: "sikkerhet",
    challenges: [
      { id: "kjoretoy", title: "Kjøretøy på anlegg" },
      { id: "veg", title: "Arbeid langs vei" },
    ],
  },
];

export function catalogFromApi(payload) {
  const themes = payload?.themes || payload?.data?.themes || payload?.data;
  if (!Array.isArray(themes) || themes.length === 0) return RISK_CATALOG;
  return themes.map((theme) => ({
    id: theme.theme || theme.id || theme.key,
    title: theme.title,
    category: theme.category || "",
    challenges: (theme.challenges || theme.items || []).map((item) => ({
      id: item.key || item.id,
      title: item.title,
      category: item.category || theme.category || "",
      consequence: item.default_consequence || item.consequence,
    })),
  }));
}

export function categoriesFromApi(payload) {
  const rows = payload?.categories || payload?.data?.categories || [];
  return Array.isArray(rows) ? rows : [];
}

export function findChallenge(themes, challengeId) {
  for (const theme of themes || []) {
    const found = (theme.challenges || []).find((item) => item.id === challengeId);
    if (found) return { theme, challenge: found };
  }
  return null;
}
